import { render, staticRenderFns } from "./host-web-entrance.vue?vue&type=template&id=0f865cd9&scoped=true&"
import script from "./host-web-entrance.vue?vue&type=script&lang=js&"
export * from "./host-web-entrance.vue?vue&type=script&lang=js&"
import style0 from "./host-web-entrance.vue?vue&type=style&index=0&id=0f865cd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f865cd9",
  null
  
)

export default component.exports